import { render, staticRenderFns } from "./asideTop.vue?vue&type=template&id=3929af94"
import script from "./asideTop.vue?vue&type=script&lang=js"
export * from "./asideTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports